import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@components/common/tooltip/main';
import LinkModal from './link-modal';

class Link extends React.Component {
  state = {
    modalOpen: false,
  }

  componentDidMount() {
    this._isMounted = true; // eslint-disable-line no-underscore-dangle
  }

  componentWillUnmount() {
    this._isMounted = false; // eslint-disable-line no-underscore-dangle
  }

  showEditModal = () => {
    this.setState({ modalOpen: true });
  }

  onUpdate = ({ name, url }) => {
    const { initial } = this.props;

    this.props.onUpdate({
      name,
      url,
      initial,
    });
  }

  onModalClose = () => {
    if (!this._isMounted) { return; } // eslint-disable-line no-underscore-dangle
    this.setState({ modalOpen: false });
  }

  renderInner() {
    const { name, url, editing } = this.props;

    // TODO: replace with URL constructor once we upgrade to the latest babel;
    // this feature isn't polyfilled by core-js until very recently.
    const tempAnchor = document.createElement('a');
    tempAnchor.href = url;
    const hostname = tempAnchor.hostname;

    const image = (
      <img
        alt={name}
        src={`https://www.google.com/s2/favicons?domain=${hostname}`}
      />
    );

    if (editing) {
      return (
        <button
          type="button"
          className="links__link-action"
          onClick={this.showEditModal}
        >
          {image}
        </button>
      );
    }

    return (
      <a
        href={url}
        className="links__link-action"
        target="_blank"
        rel="noopener noreferrer"
      >
        {image}
      </a>
    );
  }

  render() {
    const { modalOpen } = this.state;
    const { url, name, editing, id, initial } = this.props;

    return (
      <React.Fragment>
        {modalOpen ? (
          <LinkModal
            name={initial ? '' : name}
            url={initial ? '' : url}
            id={id}
            onUpdate={this.onUpdate}
            onClose={this.onModalClose}
            brandfolderKey={this.props.brandfolderKey}
          />
        ) : null}

        <li className={`links__link ${editing ? 'links__link--editing' : ''}`}>
          {name === '' ? this.renderInner() : (
            <Tooltip
              tooltipId={`link-name-${id}`}
              tooltipContent={editing ? `${t('Edit')} ${name}` : name}
            >
              {this.renderInner()}
            </Tooltip>
          )}
        </li>
      </React.Fragment>
    );
  }
}

Link.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  initial: PropTypes.bool,
  brandfolderKey: PropTypes.string.isRequired,
  editing: PropTypes.bool,
  onUpdate: PropTypes.func,
};

Link.defaultProps = {
  editing: false,
  initial: false,
  onUpdate: () => {},
};

export default Link;
